<template>
  <div id="noon-report-header">
    <div class="header-content-row1">
      <div class="aisea-text-28-400-black mb-2 vessel-name">
        {{ vesselName }}
      </div>
      <div class="button-area">
        <div v-for="(item, index) in transactionButtons">
          <vs-button
            v-if="item.is_progress"
            class="mr-2"
            :color="AISEA_COLOR.BLUE"
            @click="clickApproval(item)"
            v-show="item.enable"
            :key="index"
          >
            {{ item.label }}
          </vs-button>
          <vs-button
            v-else
            class="mr-2"
            type="border"
            :color="AISEA_COLOR.BLUE"
            @click="clickApproval(item)"
            v-show="item.enable"
            :key="index"
          >
            {{ item.label }}
          </vs-button>
        </div>
        <vs-dropdown
          :vs-trigger-click="true"
          :color="AISEA_COLOR.BLUE"
          class="cursor-pointer"
        >
          <vs-button :color="AISEA_COLOR.BLUE" type="border" icon="more_horiz">
          </vs-button>

          <vs-dropdown-menu style="width: 180px">
            <vs-dropdown-item
              v-for="(item, index) in menuItems"
              :key="index"
              @click="item.method"
              :color="AISEA_COLOR.BLUE"
              :disabled="item.disabled()"
              class="py-1"
            >
              <span class="flex items-center">
                <feather-icon
                  :icon="item.icon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>{{ item.name }}</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>
    <div class="header-content-row2">
      <div
        v-for="(item, index) in headerItems"
        :key="index"
        class="meta-blocks aisea-text-14-400-black"
        :class="item.class"
      >
        {{ item.label }}<br />
        <span class="aisea-text-14-400-gray">{{ item.value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("vesselNoonReportDetail");
import moment from "moment-timezone";
import _ from "lodash";

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  components: {},
  data() {
    return {
      headerItems: null,
      menuItems: [
        {
          icon: "Edit2Icon",
          name: "動静連絡を編集",
          method: this.clickEdit,
          disabled: this.disabled,
        },
        {
          icon: "PrinterIcon",
          name: "プリント",
          method: this.clickPrint,
          disabled: () => {
            return false;
          },
        },
        {
          icon: "ClockIcon",
          name: "変更履歴",
          method: this.clickHistory,
          disabled: () => {
            return false;
          },
        },
      ],
      openMenu: true,
    };
  },
  computed: {
    ...mapState([
      "created",
      "updated",
      "sender",
      "vesselDetail",
      "workflowStatus",
      "histories",
    ]),

    vesselName() {
      if (!this.vesselDetail) return;
      const name = this.vesselDetail.name_ja
        ? this.vesselDetail.name_ja
        : this.vesselDetail.name;
      return name;
    },
    createdText() {
      if (!this.created) return "";
      return moment(this.created).format("YYYY/MM/DD HH:mm");
    },
    updatedText() {
      if (!this.updated) return "";
      return moment(this.updated).format("YYYY/MM/DD HH:mm");
    },
    statusText() {
      if (!this.workflowStatus) return "";
      return this.workflowStatus.label;
    },
    approvalText() {
      if (!this.workflowStatus) return "";
      if (!this.workflowStatus.transactions) return "";

      const transactionLength = this.workflowStatus.transactions.length;

      //トランザクションが存在しない場合は最終承認者の名前を表示
      if (transactionLength === 0) {
        const lastApproval = this.histories[0];
        if (!lastApproval.changerProfile) return "";
        return lastApproval.changerProfile.name;
      }

      //承認トランザクションの承認者の名前を表示
      const approvalTransaction = this.workflowStatus.transactions.find(
        item => {
          return item.is_progress && item.changer_profile.name;
        }
      );

      return approvalTransaction.changer_profile.name;
    },

    transactionButtons() {
      if (!this.workflowStatus.transactions) return [];
      const _transactions = _.cloneDeep(this.workflowStatus.transactions);
      console.log(_transactions);
      return _transactions.sort((a, b) => {
        if (!a.is_progress && !b.is_progress) return 0;
        if (a.is_progress) return -1;
        if (b.is_progress) return 1;
      });
    },

    isDisabledEdit() {
      if (!this.workflowStatus) return true;
      return !this.workflowStatus.editable;
    },
  },
  watch: {
    sender(val, old) {
      this.crateHeaderItems();
    },
  },
  methods: {
    clickEdit() {
      this.$emit("clickEdit");
    },
    clickPrint() {
      this.$emit("clickPrint");
    },
    clickHistory() {
      this.$emit("clickHistory");
    },
    clickApproval(transaction) {
      this.$emit("clickApproval", transaction);
    },
    disabled() {
      return this.isDisabledEdit;
    },
    crateHeaderItems() {
      this.headerItems = [
        {
          label: "送信日時:",
          value: moment(this.created).format("YYYY/MM/DD HH:mm") || "-",
        },
        {
          label: "送信者:",
          value: this.sender.name || "-",
        },
        {
          label: "ステータス:",
          value: this.workflowStatus.label || "-",
        },
        {
          label: "承認者:",
          value: this.approvalText || "-",
        },
        {
          label: "更新日時:",
          value: moment(this.updated).format("YYYY/MM/DD HH:mm") || "-",
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/vessel-noon-report.scss";

#noon-report-header {
  --vs-primary: 3, 155, 229;
}

.header-content-row1 {
  display: flex;
  justify-content: space-between;

  .vessel-name {
    text-align: left;
    float: left;
  }

  .button-area {
    display: flex;
    justify-content: center;
    align-items: center;

    .includeIconOnly {
      width: 42px !important;
      height: 42px !important;
    }
  }
}

.header-content-row2 {
  display: flex;
  justify-content: flex-start;
  margin-top: 24px;
  margin-bottom: 12px;

  .meta-blocks {
    width: 200px;
  }
}

@page {
  size: A4 portrait;
  margin: 0;
}

@media print {
  .header-content-row1 {
    .button-area {
      display: none;
    }
  }
}
</style>
